package com.parmartechnologies.core.feature.cart.network

import com.parmartechnologies.core.feature.business.model.Business
import com.parmartechnologies.core.feature.customer.model.Customer
import com.parmartechnologies.core.feature.product.model.ProductPrice
import com.parmartechnologies.core.feature.sale.model.Sale
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.time.Clock
import kotlin.time.ExperimentalTime

@Serializable
data class CreateCustomerInvoiceRequest @OptIn(ExperimentalTime::class) constructor(
    @SerialName("invoice_id") var InvoiceId: Long = Clock.System.now().epochSeconds,
    @SerialName("user_id") var UserID: String = "",
    @SerialName("business_id") var BusinessID: String = "",
    @SerialName("store_id") var storeId: String = "",
    @SerialName("selected_business_id") var SelectedBusinessID: String = "",
    @SerialName("Business") var Business: Business? = null,
    @SerialName("customer_id") var CustomerID: String = "",
    @SerialName("customer_name") var CustomerName: String = "",
    @SerialName("Customer") var Customer: Customer? = null,
    @SerialName("device_id") var DeviceID: String = "",
    @SerialName("sales") var Sales: List<Sale> = arrayListOf(),
    @SerialName("pricing") var Pricing: ProductPrice? = null,
    @SerialName("instant_discount") var InstantDiscount: Double = 0.0,
)

